import type { DemandRequiredStatus } from "./customizationService";

/** 人工创建行程被必填项拦住时的提示。 */
export type ManualItineraryCreationBlock = {
  title: string;
  message: string;
};

/** 判断人工创建行程是否因必填项未保存完成而需要提示。 */
export function resolveManualItineraryCreationBlock(input: {
  hasExistingItinerary: boolean;
  persistedStatus: DemandRequiredStatus["status"];
  displayedStatus: DemandRequiredStatus["status"];
  displayedText: string;
  saveActionLabel: string;
}): ManualItineraryCreationBlock | null {
  if (input.hasExistingItinerary) {
    return null;
  }
  if (input.displayedStatus !== "complete") {
    return {
      title: "必填项未完成",
      message: `${input.displayedText}。请补齐后点击“${input.saveActionLabel}”保存，保存成功后才能人工创建行程。`,
    };
  }
  if (input.persistedStatus !== "complete") {
    return {
      title: `请先${input.saveActionLabel}`,
      message: `必填项已填写，但尚未更新保存。请先点击“${input.saveActionLabel}”保存，保存成功后才能人工创建行程。`,
    };
  }
  return null;
}
